module.exports = __webpack_public_path__ + "img/verified.b76a78de.png";